<template>
  <div class="ml-4 mr-4">


    <b-row>
      <b-col class="col-md-1">Date: {{ selectedProgramInfo.ReportTime | formatDate}}</b-col>
      <b-col class="col-md-5">mPortal: Deal Information</b-col>
    </b-row>
    <b-row class="mb-2">
      <b-col class="col-md-6" style="font-size:16px"> <strong> Program Information Sheet </strong> </b-col>
    </b-row>

      <b-card class="w-55 mt-4 " >
        <div slot="header">
          <strong>
            {{selectedProgramInfo.InvType}} {{selectedProgramInfo.Year}} {{selectedProgramInfo.Make}} {{selectedProgramInfo.Model}} {{selectedProgramInfo.Trim}} {{selectedProgramInfo.Color}}
          </strong>
        </div>
        <b-card-body class="m-0 p-0">
          <b-row class="row">
            <b-col class="col-md-6" md="6">
              Account#: {{selectedProgramInfo.Account}}
            </b-col>
            <b-col class="col-md-6" md="6">
              Dealership: {{selectedProgramInfo.DealershipName}}
            </b-col>
          </b-row>
          <b-row class="row">
            <b-col class="col-md-6" md="6">
              Stock#: {{selectedProgramInfo.StockNumber}}
            </b-col>
            <b-col class="col-md-6" md="6">
              VIN: {{selectedProgramInfo.VIN}}
            </b-col>
          </b-row>
          <b-row class="row">
            <b-col md="6" class="col-md-6">
              <div>
                Customer: {{selectedProgramInfo.CustomerName}}
              </div>
              <div>
                Credit Score: {{selectedProgramInfo.CreditScore}}
              </div>
              <div>
              </div>
            </b-col>
            <b-col md="6" class="col-md-6">
              <div>
                Sales Person: {{selectedProgramInfo.SalesPerson}}
              </div>
              <div>
                Payment: ${{selectedProgramInfo.MonthlyPayment}}
              </div>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
      <b-card v-for="data, index in selectedProgramInfo.UI" :id="`${data.Description}`" class="w-55 mt-4 no-break" style="padding:0px">
        <strong v-if="data.Description === 'Lender Program Results'" slot="header" style="margin:0px; padding:0px">
          {{selectedProgramInfo.Description}}
        </strong>
        <strong v-else slot="header" style="margin:0px; padding:0px">{{data.Description}}</strong>
        <div class="uipanel">
          <div v-for="panel in data.Panels" v-if="panel.Items != null && panel.Items.length > 0" class="subpanel"
               v-bind:class="{'recap': data.Description.includes('Fees') || data.Description.includes('Down Payment')|| data.Description.includes('Incentives Recap') || panel.Description.includes('Financed')}">
            <strong style="border-bottom:2px solid darkgrey;  display:block; margin:5px; padding:2px;">{{filterPanelHeader(panel.Description)}}</strong>
            <table class="table" style="margin:0px; padding:0px">
              <thead> <tr> <th></th> <th></th> <th></th> </tr> </thead>
              <tbody>
                <tr v-for="item in panel.Items" v-if="item.Description != 'Vehicle' && item.Description != 'VIN'">
                  <td style="width:65%">{{item.Description}} {{item.DescriptionValue}}</td>
                  <td><span> {{item.Symbol == '' ? '&nbsp;' : item.Symbol}}</span></td>
                  <td align="right" style="width:30%">
                    <span v-if="item.Subkind === 1" style="color: red; font-weight:600">{{item.Value}}</span>
                    <span v-else-if="item.Subkind === 2" style="color: green; font-weight:600">{{item.Value}}</span>
                    <span v-else>{{item.Value}}</span>
                  </td>
                  <td v-if="item.Description === 'Amount'">
                    <div class="mb-5"></div>
                  </td>
                </tr>
              </tbody>

            </table>
          </div>
        </div>
      </b-card>
      <b-row>
        <b-col md="6" class="col-md-6" style="font-size:16px;text-align:center;">Copyright ©   Market Scan Information Systems, Inc.. All rights reserved. </b-col>
      </b-row>

  </div>
</template>
<script>
import Vue from 'vue'
  import axios from 'axios'
  import moment from 'moment'

export default {
  name: 'ProgramInfo',
  components: {
  },
  created() {
      this.getProgramInfo(this.$route.params.token)
  },
  data () {
    return {
      selectedProgramInfo: { 'UI': [] },
      programString: '',
      errors: [],
      TodayDate : null,
      errMsg: '',
    }
  },

  methods: {

    getProgramInfo (token) {
      var self = this

      axios.get('/api/programinfo/RetrieveProgramInfo?key=' + token)
        .then(response => {
          self.selectedProgramInfo = JSON.parse(response.data.data)
          
          //var RegistrationFeesSource = self.selectedProgramInfo.RegistrationItem

          //var RegistrationFeeItemTotal = {
          //  Description: 'Total',
          //  Value: '' + self.selectedProgramInfo.RegistrationFee
          //}
          //RegistrationFeesSource.push(RegistrationFeeItemTotal)
          //var RegistrationFeeItem = {
          //  Description: 'Registration Fees',
          //  Value: '$' + self.selectedProgramInfo.RegistrationFee
          //}

          //var Panel = {
          //  Description: 'Fees',
          //  Items: this.getRegistrationFees(RegistrationFeesSource),
          //  Name: 'Fees'
          //}
          //var RegistrationFees = {
          //  Description: 'Registration Fees',
          //  Name: 'Body',
          //  Panels: []
          //}
          //RegistrationFees.Panels.push(Panel)
          //self.selectedProgramInfo.UI.push(RegistrationFees)
          //var InceptionFeesFromSource = this.GetInceptionFeesFromOriginal(RegistrationFees)
          //var InceptionFees = this.GetInceptionFees(InceptionFeesFromSource, RegistrationFeesSource)
          //InceptionFees = this.AddRegistrationFeesToInceptionFees(RegistrationFeeItem, InceptionFees)

          //this.SetInceptionFeesInOriginal(InceptionFees)
        })
        .catch(error => {
          console.log(error)
        })
    },
    AddRegistrationFeesToInceptionFees (RegistrationFeeItem, InceptionFees) {
      var NewArray = []
      for (var i = 0; i < InceptionFees.length; i++) {
        var element = InceptionFees[i]
        if (i == 2) {
          NewArray.push(RegistrationFeeItem)
          NewArray.push(element)
        } else {
          NewArray.push(element)
        }
      }
      return NewArray
    },
    GetInceptionFees (InceptionFeesFromSource, RegistrationFees) {
      var InceptionFees = []
      for (var i = 0; i < InceptionFeesFromSource.length; i++) {
        var inceptionFee = InceptionFeesFromSource[i]
        var found = false
        for (var j = 0; j < RegistrationFees.length; j++) {
          var RegistrationFee = RegistrationFees[j]

          if (inceptionFee.Description == RegistrationFee.Description + ':') {
            found = true
          }
        }
        if (!found) {
          InceptionFees.push(inceptionFee)
        }
      }
      return InceptionFees
    },
    GetInceptionFeesFromOriginal (RegistrationFees) {
      var InceptionFees = []
      for (var i = 0; i < RegistrationFees.Panels[0].Items.length; i++) {
        // var RegistrationFee = RegistrationFees.Panels[0].Items[i];
        var BreakFor = false
        for (var j = 0; j < this.selectedProgramInfo.UI.length; j++) {
          var UIElement = this.selectedProgramInfo.UI[j]
          if (UIElement.Description == 'Inception Fees') {
            for (var x = 0; x < UIElement.Panels.length; x++) {
              var SubPanel = UIElement.Panels[x]
              if (SubPanel.Description == 'Fees') {
                return SubPanel.Items
              }
              if (BreakFor) {
                break
              }
            }
          }
        }
      }
      return InceptionFees
    },
    SetInceptionFeesInOriginal (InceptionFees) {
      for (var j = 0; j < this.selectedProgramInfo.UI.length; j++) {
        var UIElement = this.selectedProgramInfo.UI[j]
        if (UIElement.Description == 'Inception Fees') {
          for (var x = 0; x < UIElement.Panels.length; x++) {
            var SubPanel = UIElement.Panels[x]
            if (SubPanel.Description == 'Fees') {
              SubPanel.Items = InceptionFees
              return
            }
          }
        }
      }
    },
    getRegistrationFees (RegistrationFees) {
      var regfees = []
      for (var i = 0; i < RegistrationFees.length; i++) {
        var element = RegistrationFees[i]
        var rfee = {
          Description: element.Description,
          DescriptionValue: null,
          Value: '$' + element.Value
        }
        regfees.push(rfee)
      }
      return regfees
    },

    clearAllPrograms () {
    },

    /* Error handling */
    hasError (response) {
      if (this.isNullOrUndefined(response)) return false

      if (response.hasOwnProperty('ErrorType') && response.hasOwnProperty('Message')) { return true }

      return false
    },

    handleError (error) {
      if (error.ErrorType === ERROR_TYPE_SHOW) {
        console.error(error.Message)
        return
      }

      if (error.ErrorType === ERROR_TYPE_TOAST) {
        this.$toastr.error(error.Message)
        return
      }

      if (error.ErrorType === ERROR_TYPE_CONSOLE) {
        return
      }

      console.error(error.Message)
    },

    handleException (error) {
      console.error(error)
      this.$toastr.error('An error occured during your request.')
      this.clearRecords()
      this.showLoading = false
    },

    getTermCellValue (row, col, data) { },

    getRebateTotalCellValue (row, col, data) { },

    /* Misc */
    isNullOrUndefined (val) { return typeof val === 'undefined' || val === null },
    clearHashBang () { window.location.hash = '#' },
    parseJsonDate: function (jsonDateString) {
      if (jsonDateString === null || typeof jsonDateString === 'undefined') return 'N/A'

      return new Date(parseInt(jsonDateString.replace('/Date(', '')))
    },
    getFormattedDate (dateObj) {
      if (dateObj === null || typeof dateObj === 'undefined') return 'N/A'

      if (dateObj === 'N/A') return dateObj

      return (dateObj.getMonth() + 1) + '/' + dateObj.getDate() + '/' + dateObj.getFullYear()
    },
    filterPanelHeader (header) {
      if (header === 'Advance') return 'Advance / Residual'
      if (header === 'Equity') return 'Cash / Equity'
      return header
    },
    toCurrency (value) {
      if (isNaN(value) || typeof value === 'undefined' || value === '' || value === null) return value

      value = value.toString()

      var dec = value.includes('.') ? '' : '.00'

      return '$' + this.toCommas(value) + dec
    },
    toDecimal (value) {
      if (isNaN(value) || typeof value === 'undefined' || value === '' || value === null) return value

      value = value.toString()

      var dec = value.includes('.') ? '' : '.00'

      return value + dec
    },
    toCommas (value) {
      if (value === null || typeof value === 'undefined') return 'N/A'

      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    isChanged (type, column, row) {
      return typeof column !== 'undefined' && typeof row !== 'undefined' && (column.changed || row.changed)
    },
  },
  mounted () {
  },
  filters: {
    formatDate: function (date) {
      var m = moment(date)
      if (m.isValid()) {
        return m.format('MM/DD/YYYY hh:mm:ss') 
      }
      return ''
    }
  }  
}
</script>

<style>
  .container {
    width: 100%;
    height: auto;
    min-height: 100vh;
    position: relative;
    float: left;
  }
  .no-break {
    page-break-inside: avoid
  }

  .dd-template {
    width: calc(100% - 39px);
  }

  .trackedLenderGreen {
    background-color: rgba(29, 191, 0, 0.37);
  }
  .trackedLenderYellow {
    background-color: rgba(255, 247, 0, 0.37);
  }
  .comparedLender {
    background-color: rgba(255, 106, 0, 0.25);
  }
  .taProgram {
    background-color: rgba(0, 126, 255, 0.25);
  }

  .table th, .table td {
    padding: 0.25rem !important;
    vertical-align: top !important;
    border-top: none !important;
  }

  .tg {
    text-align: center;
  }

  .programInfoBody {
    max-height: calc(100vh - 225px);
  }

  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  strong {
    font-weight: 600 !important;
  }

  .wide-table {
    width: 100%
  }

  #programInformationDialog .modal-lg {
    max-width: 1600px;
  }

  #programInformationDialog .modal-body {
    padding: 0px !important;
  }

  #programInformationDialog .modal-header {
    border-bottom: 0px !important;
  }
  /* Rebate Dialog */
  #rebateInformationDialog .modal-lg {
    max-width: 1850px;
  }

  #rebateInformationDialog .modal-body {
    padding: 0px !important;
  }

  #rebateInformationDialog .modal-header {
    border-bottom: 0px !important;
  }

  #rebateInformationDialog tr:nth-child(even) {
    background: white;
  }

  #rebateInformationDialog tr:nth-child(odd) {
    background: lightgray;
  }

  /* Other */

  .selectwidthauto {
    width: auto !important;
  }

  .hidden_header {
    display: none;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 4s;
  }

  .expand-button-enter-active {
    transition: all .3s ease;
  }

  .expand-button-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(10px);
    opacity: 0;
  }

   .uipanel {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-content: flex-start;
    list-style: none;
    margin: 0;
    padding: 0;
    max-height: 70em;
    min-width: 100%;
  }
  .subpanel {
    min-width:50%;
    
    display:block;
  }
  .recap {
    width:100% !important;
  }

@page { margin: 50px }
</style>



// WEBPACK FOOTER //
// src/views/ProgramInfo.vue